import EmptyState from "~/components/shared/EmptyState";

type Props = {
  job: {
    id: string;
  };
};

export default function JobAnnotations({ job }: Props) {
  // TODO: Fetch and display job-scoped annotations
  // For now, just show the empty state as specified in the issue

  return (
    <div className="mb-3 flex w-full flex-1 items-center justify-center bg-slate-100">
      <EmptyState
        heading="No annotations"
        subheading={
          <>
            <span>
              There are no annotations for this job. To scope annotations to your job, use the{" "}
            </span>
            <a
              href="https://buildkite.com/docs/agent/v3/cli-annotate"
              target="_blank"
              rel="noopener noreferrer"
              className="monospace"
            >
              buildkite-agent annotate --scope=job
            </a>
            <span> command.</span>
          </>
        }
      />
    </div>
  );
}
